export default {
    mecanicos: [],
    mecanico: {},
    ultimaAtualizacaoListaMecanico: Date
}